import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import axios from "axios";
import Home from "./pages/Home";
import About from "./pages/About";
import Help from "./pages/Help";
import Privacy from "./pages/Privacy";
import RefundPolicy from "./pages/RefundPolicy";
import Contact from "./pages/Contact";
import Store from "./pages/Store";
import Terms from "./pages/Terms";
import CycleCalculatorPage from "./pages/CycleCalculatorPage";
import Contribute from "./pages/Contribute";
import NotFound from "./pages/NotFound";
import ConnectionTerminated from "./pages/ConnectionTerminated";
import OfflineRedirect from "./components/OfflineRedirect";
import LiveChat from "./components/LiveChat";

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <OfflineRedirect />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cycle-calculator" element={<CycleCalculatorPage />} />
          {/* <Route path="/store" element={<Store />} /> */}
          <Route path="/contribute" element={<Contribute />} />
          <Route path="/connection-terminated" element={<ConnectionTerminated />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <LiveChat />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
